module.exports = [{
      plugin: require('/tmp/63e8e4e/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/63e8e4e/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
